// Copyright 1999-2023. Plesk International GmbH. All rights reserved.

export const intentIconMap = {
  info: 'info-circle-filled',
  success: 'check-mark-circle-filled',
  warning: 'triangle-exclamation-mark-filled',
  danger: 'exclamation-mark-circle-filled',
  inactive: 'cross-mark-circle-filled'
};